import SubscriberMutations from "./subscriber/subscriber.mutation";

const SubscriberServices = {
  ...SubscriberMutations,
};
export default SubscriberServices;
